module.exports = __webpack_public_path__ + "static/media/facebook-blue.058a1e67.svg";